module.exports = __webpack_public_path__ + "img/P150T_weapon_77.62bc03d3.png";